import { intlFormat } from 'date-fns';

export default (date) => (
  date
    ? intlFormat(new Date(date), {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'utc',
    }, { locale: document.documentElement.lang || 'en' })
    : ''
);
